import React from "react";
import { useGlobalContext } from "../../utils/globalContext";

const SectionHeading = ({ title, subtitle }) => {
  const { Trans } = useGlobalContext();
  return (
    <div className="sectionHeading">
      <div className="subtitle">
        <Trans>{subtitle}</Trans>
      </div>
      {title && <div className="title" dangerouslySetInnerHTML={{ __html: title }} />}
    </div>
  );
};

export default SectionHeading;
